import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierInvoicesComponent } from './supplier-invoices.component';

const routes: Routes = [
  { path: '', component: SupplierInvoicesComponent, data: { title: 'Invoices' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierInvoicesRoutingModule {}

@NgModule({
  imports: [
    SupplierInvoicesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [SupplierInvoicesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierInvoicesModule {}
